// @flow
import axios from 'lib/defaultClient';

export const getForMe = payload => axios.post(`/me/cart`, payload);
export const getAsNonRegisteredForMe = payload => axios.post(`/me/non-registered/cart`, payload);
export const addItemForMe = payload => axios.post(`/me/cart/items`, payload);
export const emptyForMe = () => axios.delete('/me/cart/items');
export const countItemsForMe = () => axios.get(`/me/cart/items/count`);
export const deleteItemForMe = itemId => axios.delete(`/me/cart/items/${itemId}`);
export const updateItemForMe = (index, itemId, payload) =>
  axios.put(`/me/cart/items/${itemId}`, payload);
export const checkoutForMe = payload => axios.post(`/me/cart/checkout/order`, payload);
export const checkoutAsNonRegisteredForMe = payload =>
  axios.post(`/me/non-registered/cart/checkout/order`, payload);



// WEBPACK FOOTER //
// ./src/lib/api/me/cart.js